import '@/styles/reset.scss';
import '@/styles/globals.scss';
import '@/styles/selects.css';
import 'keen-slider/keen-slider.min.css';
import 'intersection-observer';
import Head from 'next/head';
import { appWithTranslation, useTranslation } from 'next-i18next';
import { useEffect, useMemo, useState } from 'react';
import { SettingsContext } from '@/utils/SettingsContext';
import API from '../api';

function App({ Component, pageProps, ...rest }) {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    Array.from(document.querySelectorAll('head > link[rel="stylesheet"][data-n-p]')).forEach(
      node => {
        node.removeAttribute('data-n-p');
      }
    );
    const mutationHandler = mutations => {
      mutations.forEach(({ target }) => {
        if (target.nodeName === 'STYLE') {
          if (target.getAttribute('media') === 'x') {
            target.removeAttribute('media');
          }
        }
      });
    };
    const observer = new MutationObserver(mutationHandler);
    observer.observe(document.head, {
      subtree: true,
      attributeFilter: ['media'],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(async () => {
    const res = await API.get(`/v1/api/setting/`);
    setSettings(res.data);
  }, []);

  useEffect(() => {
    document.ondragstart = () => false;
    document.onselectstart = () => false;
    document.oncontextmenu = () => false;
  }, []);

  const getLayout = Component.getLayout || (page => page);
  const { t } = useTranslation(['common', 'layout']);
  return (
      <>
        <Head>
          <meta name="yandex-verification" content="355be7403f90b38b"/>
          <link rel="preload" as="style" href="/static/fonts/fonts.css"/>
          <link rel="stylesheet" href="/static/fonts/fonts.css"/>

          <script
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html: `(function(m,e,t,r,i,k,a){
                  m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                  m[i].l=1*new Date();
                  for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                  k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
                })(window, document,'script','https://mc.yandex.ru/metrika/tag.js', 'ym');

                ym(87301398, 'init', {webvisor:true, clickmap:true, accurateTrackBounce:true, trackLinks:true});`,
              }}
          />
        </Head>
        <noscript>
          <div>
            <img
                src="https://mc.yandex.ru/watch/87301398"
                style={{position: 'absolute', left: '-9999px'}}
                alt=""
            />
          </div>
        </noscript>
        <SettingsContext.Provider value={settings}>
          {getLayout(<Component {...pageProps} />, t)}
        </SettingsContext.Provider>
      </>
  );
}

export default appWithTranslation(App);
